export default "#wc .proj-runner-container{background-color:var(--rpf-off-white);border:2px solid var(--rpf-grey-100);box-sizing:border-box}\n"